<template>
  <div>
    <slot />
    <ClientOnly>
      <CookiesCookieBar v-if="data?.cookieNotification" :body="data.cookieNotification" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import type { InitializationResponseModel } from '@api';

const { getSetup } = useApi();

const { data } = await useAsyncData<InitializationResponseModel | undefined>(`setup`, async () => {
  try {
    return await getSetup();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
});

useHead({
  script: data.value?.header?.headTrackingScripts?.map((script, index) => ({
    key: `headTrackingScripts-${index}`,
    innerHTML: script,
    type: 'text/javascript',
    tagPosition: 'head',
  })),
  noscript: data.value?.header?.bodyTrackingScripts?.map((script, index) => ({
    key: `bodyTrackingScripts-${index}`,
    innerHTML: script,
    tagPosition: 'bodyOpen',
  })),
});
</script>
